import TextIcon from 'src/pages/dashboard/icons/text-icon'
import UploadIcon from 'src/pages/dashboard/icons/upload-icon'
import { useRouter } from 'vue-router'
import { MdButton } from '@antiqua-dls/vue-components'

export default{
  components:{
    TextIcon,
    UploadIcon,
    MdButton
  },
  setup(){
    const router = useRouter()
    const createNewSubmission = () => {
      router.push({name:'home'})
    }
    return{
      createNewSubmission
    }
  }
}
